import React, { useState, useEffect } from 'react';
import { API } from '../../App';
import axios from 'axios';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { toast } from 'sonner';
import { Database, Users, Calendar, Activity } from 'lucide-react';

export default function AdminDashboard() {
  const [stats, setStats] = useState({
    users: 0,
    exhibitions: 0,
    requests: 0,
    layouts: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      const [usersRes, exhibitionsRes, requestsRes] = await Promise.all([
        axios.get(`${API}/users`, { headers }),
        axios.get(`${API}/exhibitions`, { headers }),
        axios.get(`${API}/requests`, { headers })
      ]);

      setStats({
        users: usersRes.data.length,
        exhibitions: exhibitionsRes.data.length,
        requests: requestsRes.data.length,
        layouts: 0
      });
      setLoading(false);
    } catch (error) {
      toast.error('İstatistikler yüklenemedi');
      setLoading(false);
    }
  };

  const statCards = [
    { label: 'Toplam Kullanıcı', value: stats.users, icon: Users, color: 'bg-blue-500' },
    { label: 'Aktif Fuarlar', value: stats.exhibitions, icon: Calendar, color: 'bg-green-500' },
    { label: 'Bekleyen Talepler', value: stats.requests, icon: Activity, color: 'bg-orange-500' },
    { label: 'Kroki Sayısı', value: stats.layouts, icon: Database, color: 'bg-purple-500' },
  ];

  return (
    <div className="p-8" data-testid="admin-dashboard">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Dashboard</h1>
        <p className="text-gray-500 mt-1">Sistem genel bakış ve istatistikler</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {statCards.map((stat) => {
          const Icon = stat.icon;
          return (
            <Card key={stat.label} data-testid={`stat-${stat.label.toLowerCase().replace(/\s+/g, '-')}`}>
              <CardContent className="pt-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-gray-500 mb-1">{stat.label}</p>
                    <p className="text-3xl font-bold">{loading ? '...' : stat.value}</p>
                  </div>
                  <div className={`${stat.color} p-3 rounded-lg`}>
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle>Son Aktiviteler</CardTitle>
            <CardDescription>Sistemdeki son hareketler</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-gray-500">Aktivite geçmişi yakında eklenecek...</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Sistem Durumu</CardTitle>
            <CardDescription>Servis sağlık kontrolü</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <span className="text-sm">Backend API</span>
                <span className="px-2 py-1 bg-green-100 text-green-800 rounded text-xs font-medium">
                  Çalışıyor
                </span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm">MongoDB</span>
                <span className="px-2 py-1 bg-green-100 text-green-800 rounded text-xs font-medium">
                  Bağlı
                </span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm">Frontend</span>
                <span className="px-2 py-1 bg-green-100 text-green-800 rounded text-xs font-medium">
                  Aktif
                </span>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}